<template>
  <div class="webs-page">
    <header-sources 
      :header-title="webDetail.title"
      :show-back-button="true" 
    />
    <div class="body-content row">
      <div class="left-content">
        <p class="head">{{ $t('WEB_SOURCES.WEB_DETAIL.TITLE') }}</p>
        <div class="info">
          <div class="item">
            <p class="title">{{ $t('WEB_SOURCES.WEB_DETAIL.ITEM_TITLE1') }}</p>
            <input type="text" class="website-detail-url" readonly="readonly" v-model="webDetail.url">
          </div>
          <div class="item">
            <p class="title">{{ $t('WEB_SOURCES.WEB_DETAIL.ITEM_STATUS') }}</p>
            <div class="item-status">
              <span
              >
                {{ $t('WEB_SOURCES.WEB_DETAIL.STATUSES.' + webDetail.status) }}
              </span>
            </div>
            
          </div>
          <div class="item">
            <p class="title">{{ $t('WEB_SOURCES.WEB_DETAIL.ITEM_TITLE2') }}</p>
            <p class="desc">{{ webDetail.title }}</p>
          </div>
          <div class="item">
            <p class="title">{{ $t('WEB_SOURCES.WEB_DETAIL.ITEM_TITLE3') }}</p>
            <p class="desc">{{ formatDateTime(webDetail.updated_at)}}</p>
          </div>
          <div class="item">
            <p class="title">{{ $t('WEB_SOURCES.WEB_DETAIL.ITEM_TITLE4') }}</p>
            <p class="desc">{{ formatDateTime(webDetail.updated_at)}}</p>
          </div>
          <div class="item">
            <p class="title">{{ $t('WEB_SOURCES.WEB_DETAIL.ITEM_TITLE5') }}</p>
            <p class="desc">{{ formatDateTime(webDetail.updated_at)}}</p>
          </div>
          <div class="item">
            <p class="title">{{ $t('WEB_SOURCES.WEB_DETAIL.ITEM_TITLE6') }}</p>
            <div class="avatar">
              <thumbnail
                :username="webDetail && webDetail.user ? webDetail.user.name : ''"
                size="32px"
              />
              <p class="desc">{{ webDetail && webDetail.user ? webDetail.user.name : '' }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="right-content">
        <div class="row item-center justify-between">
          <woot-tabs
            :index="activeTabIndex"
            @change="onTabChange"
            :border="false"
          >
            <woot-tabs-item 
              v-for="tab in tabs"
              :key="tab.key"
              :name="tab.name"
              :count="tab.count"
              :disabled="typeof tab.count === 'string'"
            >
            </woot-tabs-item>
          </woot-tabs>

          <woot-button
            v-if="activeTab === 0"
            variant="smooth"
            size="small"
            color-scheme="secondary"
            class-names="grey-btn"
            icon="delete"
            @click="showDeleteResourcePopup = true"
          >
            {{ $t('WEB_SOURCES.WEB_DETAIL.DELETE_RESOURCE.BUTTON_TEXT') }}
          </woot-button>
        </div>
        <web-table-url @selectrows="updateSelectedUrlRows" :class="{'d-none': activeTab !== 0}" />
        <web-table-question v-if="webDetail.status === 'generated'" @selectrows="updateSelectedQuestionRows" :class="{'d-none': activeTab !== 1}" />
      </div>
    </div>
     <!-- Delte all resource -->
    <woot-delete-modal
      :show.sync="showDeleteResourcePopup"
      :on-close="closeDeleteResource"
      :on-confirm="deleteResource"
      :title="$t('WEB_SOURCES.ACTIONS.DELETE.CONFIRM.TITLE')"
      :message="$t('WEB_SOURCES.ACTIONS.DELETE.CONFIRM.MESSAGE')"
      :message-value="''"
      :confirm-text="$t('WEB_SOURCES.ACTIONS.DELETE.CONFIRM.YES')"
      :reject-text="$t('WEB_SOURCES.ACTIONS.DELETE.CONFIRM.NO')"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import globalConfigMixin from 'shared/mixins/globalConfigMixin';
import CreateScrapeWebsite from './components/CreateScrapeWebsite.vue';
import HeaderSources from './components/Header.vue';
import TableFooter from 'dashboard/components/widgets/TableFooter';
import WebTableUrl from './components/DetailWebTableUrl.vue';
import WebTableQuestion from './components/DetailWebTableQuestion.vue';
import format from 'date-fns/format';
import Avatar from 'dashboard/components/widgets/Avatar';
import Thumbnail from 'dashboard/components/widgets/Thumbnail.vue';

export default {
  name: 'WebsSources',
  components: {
    CreateScrapeWebsite,
    HeaderSources,
    TableFooter,
    WebTableUrl,
    WebTableQuestion,
    Avatar,
    Thumbnail
  },
  props: {
    
  },
  mixins: [globalConfigMixin],
  data() {
    return {
      showDeleteResourcePopup: false,
      selectedTabIndex: 0,
      tabs: [
          {
              "key": 0,
              "name": this.$t('WEB_SOURCES.WEB_DETAIL.TAB_NAME.URL'),
              "count": 0
          },
          {
              "key": 1,
              "name": this.$t('WEB_SOURCES.WEB_DETAIL.TAB_NAME.QUESTION'),
              "count": 0
          },
      ],
      activeTab: 0,
      selectedUrlRows: [],
      selectedQuestionRows: []
    };
  },
  computed: {
    ...mapGetters({
      webDetail: 'webs/getWeb',
      webList: 'webs/getWebs',
      webListUrls: 'webs/getWebUrls',
      webListUrlsMeta: "webs/getWebUrlsMeta",
      webListQuestions: "webs/getWebQuestions",
      webListQuestionsMeta: "webs/getWebQuestionsMeta",
      uiFlags: 'webs/getUIFlags',
      meta: 'webs/getMeta',
    }),
    webData() {
      const { webId } = this.$route.params;
      return this.$store.getters['webs/getWebs'](webId);
    },
    activeTabIndex() {
      return this.tabs.findIndex(tab => tab.key === this.activeTab);
    },
  },
  mounted() {
    const { webId } = this.$route.params;
    this.fetchDetailWeb(webId).then(() => {
      if (this.webDetail.status !== 'generated') {
        this.updateTabCount(1, this.$t('WEB_SOURCES.WEB_DETAIL.TAB_BADGES.' + this.webDetail.status));
      }

      if (this.webDetail.status === 'generating') {
        this.checkGeneratingStatus(webId);
      }
    });
  },
  methods: {
    updateSelectedUrlRows(selectedUrlRows) {
      this.selectedUrlRows = selectedUrlRows
    },
    updateSelectedQuestionRows(selectedQuestionRows) {
      this.selectedQuestionRows = selectedQuestionRows
    },
    async fetchDetailWeb(id) {
      await this.$store.dispatch('webs/show', { id })
    },
    checkGeneratingStatus(id) {
      this.$store.dispatch('webs/checkGeneratingStatus', { id })
    },
    onTabChange(selectedTabIndex) {
      if (this.tabs[selectedTabIndex].key !== this.activeTab) {
        this.activeTab = this.tabs[selectedTabIndex].key;
      }
    },
    updateTabCount( index, newCount ) {
      this.tabs = this.tabs.map((tab,i) => i === index ? ({...tab, count: newCount}) : tab)
    },
    closeDeleteResource(){
      this.showDeleteResourcePopup = false
      this.selectedUrlRows = []
      this.selectedQuestionRows = []
    },
    async deleteResource() {
      if (this.activeTab === 0) {
        await this.$store.dispatch('webs/deleteUrlResource', { website_id: this.webDetail.id, website_page_ids: this.selectedUrlRows })

        this.selectedUrlRows = []

        this.closeDeleteResource();
        this.showAlert(this.$t('WEB_PAGE_SOURCES.ACTIONS.DELETE.API.SUCCESS_MESSAGE'));
      } else if (this.activeTab === 1) {
        await this.$store.dispatch('webs/deleteQuestionResource', { website_id: this.webDetail.id, website_question_ids: this.selectedQuestionRows })

        this.selectedQuestionRows = []

        this.closeDeleteResource();
        this.showAlert(this.$t('QUESTION_SOURCES.ACTIONS.DELETE.API.SUCCESS_MESSAGE'));
      }
    },
    showAlert(message) {
      bus.$emit('newToastMessage', message);
    },
    formatDateTime(date) {
      return `Today ` + ( date ? format(new Date(date), 'HH:mm') : '' );
    },
  },
  watch : {
    webListUrls ( newWeb, oldWeb ) {
      this.updateTabCount(0, this.webListUrlsMeta.totalEntries)
    },
    webListQuestions ( newWeb, oldWeb ) {
      this.updateTabCount(1, this.webListQuestionsMeta.totalEntries)
    }
  },
};
</script>

<style scoped lang="scss">
.webs-page {
  width: 100%;
}
.item-center {
  align-items: center;
}
.justify-between {
  justify-content: space-between;
}
.body-content {
  height: 100%;
  border-top: 1px solid var(--s-50);
}
.left-content {
  width: 312px;
  padding: 16px;
}

.info {
  display: grid;
  gap: 12px;
  margin-top: 12px;
}
.title, .input-container > span,.text {
  color: var(--s-400);
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
}
.desc,.head,.count-url {
  color: var(--color-body);
  font-size: 14px;
  font-weight: 600;
}
.head,.title {
  text-transform: uppercase;
}
.item-status {
  border-radius: 4px;
  background: #CCE6FF;
  padding: 3px 12px;
  color: var(--w-500);
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  width: fit-content;
}
.head {
  margin-bottom: 16px;
}
input {
  margin-bottom: 0;
}
.right-content {
  flex: 1 1;
}
.tabs-title.is-active a {
  font-weight: 500;
}

.grey-btn {
  border: 1px solid  var(--s-100) !important;
  background: var(--s-50) !important;
}
.avatar {
  width: fit-content;
  border-radius: 5rem;
  border: 1px solid var(--s-100);
  background: var(--s-50);
  display: flex;
  padding: 6px 16px 6px 8px;
  align-items: center;
  gap: 8px;
  .desc {
    margin-bottom: 0;
  }
}
.website-detail-url {
  font-size: 14px;
  background: #f1f5f8;
}
.d-none {
  display: none;
}
</style>
